import { AxiosPromise } from 'axios';
import { csttFacadeApi } from '@cd/sdds-common-components-react';

const createDefinition = (payload: Definitionto): AxiosPromise<any> => csttFacadeApi.post('/csttfacade/docs/v1/csddefinition', payload)
const updateDefinition = (payload: Definitionto): AxiosPromise<any> => csttFacadeApi.put('/csttfacade/docs/v1/csddefinition', payload)
const getAllFunctions = (): AxiosPromise<deFunction> => csttFacadeApi.get(`/csttfacade/tsguide/v1/functions/`)

export { createDefinition, updateDefinition, getAllFunctions}